// extracted by mini-css-extract-plugin
module.exports = {"menu":"Nav_menu__1CGZa","hasExtraLink":"Nav_hasExtraLink___sjqS","current":"Nav_current__UMGgb","extraLink":"Nav_extraLink__7gsOu"};